/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import { compact } from 'lodash';
/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { stopEditingLocationWebsite } from 'state/ui/location-website-modal/actions';
import { getLocationWebsiteId } from 'state/ui/location-website-modal/selectors';
import { getEditedLocationWebsite } from 'state/location-websites/selectors';
import LocationWebsiteForm from 'blocks/location-website-form';
import { deleteLocationWebsite } from 'state/location-websites/actions';
import {successNotice} from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const EditLocationWebsiteModal = ({ locationWebsiteId, locationWebsite, connectionLocations, connectionId, isVisible, disabled, disabledExternalLocation, close, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const isNew = !locationWebsiteId;
    const title = isNew ? 'Create website location' : 'Edit website location';

    const handleDelete = async () => {
        if (isNew) {
            return;
        }
        setDeleting(true);
        try {
            await props.deleteLocationWebsite(locationWebsiteId);
            close();
        } catch (error) {}
        setDeleting(false);
    };

    const buttons = compact([
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        !isNew && {
            key: 'delete',
            label: deleting ? 'Deleting' : 'Delete',
            onClick: handleDelete,
        },
        {
            key: 'save',
            label: submitting ? 'Saving' : 'Save',
            form: 'location-website-form',
            type: 'submit',
            disabled: submitting,
            primary: true,
        },
    ]);

    const onSuccess = () => {
        close();
        props.successNotice('Saved');
    }

    return (
        <Modal title={title} className='create-connection-modal' close={close} isVisible={isVisible} buttons={buttons}>
            <Box padding='xlarge'>
                <LocationWebsiteForm
                    locationWebsiteId={locationWebsiteId}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={onSuccess}
                    locationWebsite={locationWebsite}
                    connectionLocations={connectionLocations}
                    connectionId={connectionId}
                    disabled={disabledExternalLocation}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('EditLocationWebsiteModal')(state),
        locationWebsiteId: getLocationWebsiteId(state),
        locationWebsite: getEditedLocationWebsite(state, getLocationWebsiteId(state)) || {},
    }),
    {
        close: stopEditingLocationWebsite,
        deleteLocationWebsite,
        successNotice
    },
)(EditLocationWebsiteModal);
